import { render } from "./coach-mybooking-court.vue?vue&type=template&id=56a89ec7"
import script from "./coach-mybooking-court.vue?vue&type=script&lang=js"
export * from "./coach-mybooking-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__